export const analyticsElementIds = {
  acceptTermsBtn: 'accept_terms_btn',
  appleBtn: 'apple_btn',
  createAccountBtn: 'create_account_btn',
  existingAccountBtn: 'existing_account_btn',
  facebookBtn: 'facebook_btn',
  forgotPasswordBtn: 'forgot_password_btn',
  getAppBtn: 'get_the_app_btn',
  googleBtn: 'google_btn',
  resendEmailBtn: 'resend_email_btn',
  sendNewPasswordBtn: 'send_new_password_btn',
  signIn: 'signin_btn',
  useAnotherAccountBtn: 'use_another_account_btn',
} as const;
